module.exports = __webpack_public_path__ + "static/img/44.b0f285b5.gif";